module.exports = __webpack_public_path__ + "img/nateev.0a475c15.svg";